import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home')
  },
  {
    path: '/synthesis',
    name: 'synthesis',
    component: () => import('@/views/synthesis')
  },
  {
    path: '/long',
    name: 'long',
    component: () => import('@/views/long')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('@/views/feedback')
  },
  {
    path: '/aboutMe',
    name: 'aboutMe',
    component: () => import('@/views/aboutMe')
  }
]

const router = new VueRouter({
  routes
})

export default router
